<!--
@负责人: xiehan
@创建时间: 2018-08-08
@版本: v1.0.20
@描述: echarts 树形图
@使用方法:
<template>
    <tree :tree-data="treeData" :tree-id="treeId" @selecttree="selectTree"></tree>
</template>
<script>
    export default {
        components: {
            tree: require('./components/tree.vue')
        },
        data() {
            return {
                treeData: null,
                treeId: 'testId'
            }
        },
        methods: {
            selectTree(info) {
                console.log(info)
            }
        },
        ready() {
            this.treeData = {
                name: 'OPS',
                children: [
                    { name: 'ucl-ops-data' }, { name: 'login-admin' }
                ],
                status: '1'
            }
        }
    }
</script>
@参数说明:
// 树形图 treeId
// 字符串 区分树形图

// 树形图数据 treeData (object)
// 数据结构
// 数据类型String---name: 节点名称
// 数据类型Object---children: 节点的子节点
// 数据类型String---status: 节点状态 '1'是绿色 '2'是黄色
// 其他可根据项目扩展如节点id,也可配置echarts自带的配置项,组件内动态生成symbol图形、symbolSize尺寸、SymbolOffset偏移位置

@事件说明
// 向上分发一个selecttree事件，传给父组件选择的树节点的信息

@补充
// 树形图样式可配置待开发
-->
<template>
    <div class="com-tree">
        <div :id="treeId" :style="treeStyle"></div>
        <i class="icon iconfont"
           :title="'child: ' + treeData.children.length"
           :class="[ isCollapsed ? 'icon-plus-square' : 'icon-minus-square' ]"
           :style="iconStyle"
           @click="expandAndCollapse"></i>
    </div>
</template>

<script>
  let echarts = require('echarts')
  const SERIES_STYLE = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    type: 'tree',
    data: [],
    expandAndCollapse: false,
    symbolOffset: ['50%', 0],
    itemStyle: {
      normal: {
        opacity: 1
      }
    },
    label: {
      normal: {
        show: false
      }
    },
    leaves: {
      label: {
        normal: {
          show: false
        }
      }
    }
  }

export default {
    props: {
      treeData: {
        type: Object,
        default () {
          return {}
        }
      },
      treeId: {
        type: String
      }
    },
    data () {
      return {
        isCollapsed: true,
        treeInstance: null,
        treeOption: {
          tooltip: {
            trigger: 'item',
            triggerOn: 'mousemove'
          },
          series: [SERIES_STYLE]
        },
        treeStyle: {
          width: '460px',
          height: '30px'
        },
        iconStyle: {
          top: '6px',
          left: 0
        }
      }
    },
    methods: {
      translateURI (canvas) {
        return canvas.toDataURL('image/png')
      },
      getStrLength (str) {
        return str.length
      },
      translateSymbolInfo (str, status) {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        canvas.width = this.getStrLength(str) * 12 + 8
        canvas.height = 28
        ctx.lineWidth = 0.8
        ctx.rect(2, 2, this.getStrLength(str) * 12 + 4, 24)
        if (status === '1') {
          ctx.fillStyle = '#24d46d'
        } else if (status === '2') {
          ctx.fillStyle = '#ffdc53'
        } else if (status === '3') {
          ctx.fillStyle = '#0087ff'
        }
        ctx.fill()
        ctx.strokeStyle = '#000'
        ctx.stroke()
        ctx.font = '20px Courier New'
        ctx.fillStyle = '#000'
        ctx.fillText(str, 4, 20)

        return {
          symbol: 'image://' + this.translateURI(canvas),
          symbolSize: [canvas.width, canvas.height]
        }
      },
      handlerData (data) {
        let treeObj = data
        treeObj = { ...treeObj, ...this.translateSymbolInfo(treeObj.name, treeObj.status) }
        // 单独设置组的symbol偏移位置
        treeObj.symbolOffset = ['48%', 0]
        treeObj.collapsed = this.isCollapsed
        let maxWidth = 0
        treeObj.children.map((item, index) => {
          treeObj.children[index] = { ...item, ...this.translateSymbolInfo(item.name, item.status) }
          if (treeObj.children[index].symbolSize[0] > maxWidth) maxWidth = treeObj.children[index].symbolSize[0]
        })
        this.autoSize(2, maxWidth, treeObj)
      },
      autoSize (left, right, data) {
        this.treeOption.series[0].left = left
        this.treeOption.series[0].right = right
        this.treeOption.series[0].data = [data]
        this.iconStyle.left = data.symbolSize[0] + 'px'
        this.initTree(this.treeId)
      },
      initTree (id) {
        const that = this
        this.treeInstance = echarts.init(document.getElementById(id))
        this.treeInstance.setOption(this.treeOption)
        this.treeInstance.on('click', function (params) {
          that.$emit('selecttree', params)
        })
      },
      expandAndCollapse () {
        if (this.isCollapsed) {
          this.iconStyle.top = this.treeData.children.length > 0 ? this.treeData.children.length * 30 / 2 - 10 + 'px' : '6px'
          this.treeStyle.height = this.treeData.children.length > 0 ? this.treeData.children.length * 30 + 'px' : '30px'
        } else {
          this.iconStyle.top = '6px'
          this.treeStyle.height = '30px'
        }
        this.isCollapsed = !this.isCollapsed
        this.handlerData(this.treeData)
      }
    },
    watch: {
      'treeData': {
        deep: true,
        handler: function (val) {
          this.handlerData(val)
        }
      },
      'treeStyle': {
        deep: true,
        handler: function () {
          const that = this
          that.$nextTick(() => {
            that.treeInstance.resize()
          })
        }
      }
    },
    mounted () {
      this.handlerData(this.treeData)
    }
}
</script>

<style scoped>
    .com-tree {
        position: relative;
        overflow: hidden;
    }
    .com-tree .iconfont {
        font-size: 20px;
        cursor: pointer;
        position: absolute;
        transition: top 1s;
        -webkit-transition: top 1s; /* Safari */
    }
</style>
